/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ikdauer1Inputs */

const de__field_ikdauer1 = /** @type {(inputs: _Field_Ikdauer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensivkursdauer in Minuten`)
};

/**

* @param {_Field_Ikdauer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ikdauer1 = /** @type {((inputs?: _Field_Ikdauer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ikdauer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ikdauer1(inputs)
});
export { _field_ikdauer1 as "_field_ikDauer" }